module.exports = __webpack_public_path__ + "media/images/icons/check-circle-260ed63fa76142c915b3fff20b01e9b8.svg";